<template>
  <div class="main-container">
    <!-- 头部导航 -->
    <header
      :class="['header', { scrolled: isScrolled }]"
      :style="{ backgroundColor: isScrolled ? '#fff' : 'transparent' }"
    >
      <div class="header-content">
        <div class="logo">
          <img src="@/assets/new-top-logo.png" alt="" v-if="!isScrolled" />
          <img src="@/assets/new-b-logo.png" alt="" v-if="isScrolled" />
        </div>

        <nav class="nav">
          <a
            v-for="(item, index) in navItems"
            :key="index"
            href="javascript:void(0);"
            :class="['nav-item', { active: currentSection === index }]"
            @click="scrollToSection(index)"
          >
            {{ item }}
          </a>
        </nav>
      </div>
    </header>

    <!-- 内容区块 -->
    <main>
      <section
        v-for="(item, index) in navItems"
        :key="index"
        :ref="
          (el) => {
            if (el) sections[index] = el;
          }
        "
        class="content-section"
      >
        <template v-if="item == 'Marketing'">
          <div class="marketing">
            <div class="marketing-name">Marketing Services</div>
            <p class="marketing-border"></p>
            <div class="marketing-cont">
              We provide a broad range of services in market investigation, consumer
              <br />
              insight, content development, campaign executions, event management,
              <br />
              CRM, and comprehensive “marketing + sales” solutions for sales and
              <br />
              promotions.
            </div>
          </div>
          <div class="business">
            <div class="business-cont">
              <div class="title">
                <p>Business</p>
                <p>Introduction</p>
              </div>
              <div class="cont">
                With “Creative/Service + Solution/Satisfaction” as our core, Uninet provides total
                marketing, sales, organizing and managing solutions for clients in Internet,
                e-commerce, finance, real estate, high-tech, consumer goods, automotive, hardware,
                textiles and other fields, serving more than 500 clients per year. The services we
                provide include market investigation, consumer insights, content development,
                event management, customer relationship management, media campaign and scenario
                marketing, etc.
              </div>
            </div>
          </div>
        </template>

        <template v-if="item == 'Incentive'">
          <div class="incentive">
            <div class="incentive-detail">
              <div class="incentive-detail-left">
                <!-- We create! We impress! We innovate! -->
                <div></div>
                <div>Incentive</div>
                <div>
                  An incentive is a great way to motivate and incentivize your company’s success.
                  <div style="height: 10px"></div>
                  We help you to have a unique experience by managing the hotel bookings, organize
                  great activities, dinners as well as unforgettable adventures, always respecting
                  your ideas, budgets and being at your full disposal throughout the entire project
                  process.
                  <div style="height: 10px"></div>
                  This includes our signature luxury customization: combining airplane travel,
                  top-tier hotels, and immersive cultural exploration itineraries.
                </div>
              </div>
              <div class="incentive-detail-right">
                <Carousel :images="images" :interval="3000"></Carousel>
              </div>
            </div>
          </div>
          <!-- <div class="incentive-services">
            <div class="services-detail">
              <div class="services-title">Services</div>
              <accordion />
            </div>
          </div> -->
        </template>

        <div v-if="item == 'Conference'" class="conference">
          <div class="conference-detail">
            <!-- Keep attendees connected at every touchpoint -->
            <div class="conference-keep"></div>
            <div class="conference-con">Conference</div>
            <div class="conference-cont">
              <img src="@/assets/Conference.png" alt="" />
              <div class="conference-cont-right">
                <div>
                  <div>Keep attendees connected at every touchpoint</div>
                  <div>
                    Our in-person event platform simplifies every stage of event planning. From
                    venue sourcing to registration, check-in and badging, and mobile event apps,
                    Uninet provides all the tools you need in one place.
                    <br />
                    Easily find the perfect venue with access to tens of thousands of options and
                    streamline the registration process with built-in tools that send reminders and
                    drive conversions.
                  </div>
                </div>
                <div>
                  <div>Maximum engagement</div>
                  <div>
                    Keep attendees connected and engaged using your event's mobile app. Attendees
                    can interact with event content through live chat, Q&A, surveys, and polling.
                    They can also network and plan meetings, ensuring active participation.
                  </div>
                </div>
                <div>
                  <div>Actionable insights</div>
                  <div>
                    Measure the success of your events with detailed analytics. Uninet provides
                    robust event and attendee insights that help you understand your event's
                    performance and improve future planning. Identify high-quality leads and
                    transfer data to your marketing tech stack for targeted follow-up campaigns.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item == 'Exhibition'" class="exhibition">
          <div class="exhibition-detail">
            <!-- <div class="exhibition-service">Exhibitor Services</div> -->
            <div class="exhibition-exhibition">exhibition</div>
            <div class="exhibition-uninet">
              Uninet started from Singapore and concentrated its activities in organizing
              exhibitions, conferences, gatherings and forums in the Middle East, Latin
              American, African and Asian Counties. For achieving its distinction, Uninet relied on
              a team of qualified expertise and administrative, technical efficiencies specialized
              in organizing the largest exhibitions and conferences for ministries, government
              bodies and authorities and companies and institutions of both private and public
              sectors, and provide entire services that ensures the achievement of the targets of
              the sponsoring bodies of the exhibitions and conferences.
            </div>
            <!-- <div class="exhibition-shipping">
              <div class="shipping-left">
                <img src="@/assets/shipping.png" alt="">
                <div>Shipping and Logistics</div>
                <div>Our highly skilled logistics team has experience shipping materials to destinations around the
                  globe. We are dedicated to making sure every piece arrives at the right destination as efficiently and
                  cost-effectively as possible.</div>
              </div>
              <div class="shipping-right">
                <img src="@/assets/cunstom.png" alt="">
                <div>Custom Exhibit Rental</div>
                <div>Create a custom, standout booth that attracts and delights attendees. Our comprehensive exhibit
                  rental packages include the exhibit rental, custom fabric graphics, material handling, and
                  professional install and dismantle labor.</div>
              </div>
            </div> -->

            <div class="exhibition-simp">
              <div class="exhibition-simp-list">
                <div>A Simplified Exhibiting Experience</div>
                <div>
                  In an attempt to improve the industry of exhibitions and conferences, Uninet has
                  also organized of a number of exhibitions of its own which satisfy the need of a
                  wide range of industries.
                </div>
                <div>
                  <div class="simp-item">
                    <img src="@/assets/simp1.png" alt="" />
                    <div>Easy Ordering</div>
                    <div>
                      Our packages combine products, labor and materials to simplify the ordering
                      process.
                    </div>
                  </div>
                  <div class="simp-item">
                    <img src="@/assets/simp2.png" alt="" />
                    <div>Cost Certainty</div>
                    <div>
                      We offer a consistent rate structure, transparent pricing, and eliminate
                      services fees whenever possible.
                    </div>
                  </div>
                  <!-- <div class="simp-item">
                    <img src="@/assets/simp3.png" alt="">
                    <div>Simplified invoicing</div>
                    <div>Our in-person event platform simplifies every stage of event planning. From venue sourcing to
                      registration.</div>
                  </div> -->
                </div>

                <div class="simp-item-btn">
                  <img src="@/assets/simp4.png" alt="" />
                  <div>Exhibitor Education</div>
                  <div>
                    We communicate to exhibitors business opportunities, participation skills,
                    suggest affordable exhibit options and how obtain the largest leads.
                  </div>
                </div>
              </div>
              <img src="@/assets/simp-bg-new.png" alt="" class="exhibition-simp-img" />
            </div>

            <div class="exhibition-footer">
              Based on Uninet confidence on its policy of improving the industry of exhibitions and
              conferences and the proficiency of its work team in realizing these policies, the
              company concluded a number of agreements with giant exhibitions organizers in a number
              of Middle East, Latin American, African and Asian countries, with a range of criterion
              relating to capability, know-how and quality.
            </div>
          </div>
        </div>

        <div v-if="item == 'Service Portfolio'" class="content-container service-bg">
          <h1>Service Portfolio</h1>
          <div class="sub-title">
            We are a global MICE leader, specializing in Marketing, Incentives, Conferences, and
            Exhibitions. Beyond our core services, we also offer integrated solutions in Real Estate
            Investment & Management, Logistics & Compliance, and an Online Trade Platform to provide
            end-to-end support for our international clients.
          </div>
          <div class="service-portfolio">
            <div class="service-ring">
              <div class="service-ring-bg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="67"
                  height="66"
                  viewBox="0 0 67 66"
                  fill="none"
                >
                  <path
                    d="M22.4448 61.0003C21.3723 61.0003 20.4813 60.1423 20.4648 59.0698C20.3988 56.3143 15.9768 53.3278 13.0398 51.3478C12.0993 50.7208 11.2248 50.1268 10.5318 49.5823C8.28779 47.8333 7.03379 44.8963 6.96779 41.3323L5.96129 28.1323V28.0003C5.94479 26.5318 6.50579 25.1623 7.54529 24.1393C8.58479 23.1163 9.95429 22.5553 11.4228 22.5883C11.5548 22.5883 11.7033 22.6048 11.8353 22.6378C14.3103 23.2153 16.0758 25.6573 16.1583 28.5778C16.3893 31.4983 16.9833 36.1183 17.5443 37.4053C18.0393 38.5273 21.1413 41.6128 23.7483 43.8073C24.5898 44.5168 24.6888 45.7708 23.9793 46.5958C23.2698 47.4373 22.0158 47.5363 21.1908 46.8268C20.1678 45.9688 15.0528 41.5303 13.9308 39.0058C12.8913 36.6298 12.3138 30.1123 12.2148 28.8418V28.7263C12.1983 27.8683 11.8188 26.8618 11.1423 26.5648C10.8453 26.5978 10.5648 26.7463 10.3503 26.9608C10.0863 27.2248 9.95429 27.5548 9.93779 27.9178L10.9443 41.1013V41.2333C10.9773 43.5763 11.7198 45.4903 12.9903 46.4968C13.5678 46.9423 14.3928 47.5033 15.2673 48.0973C19.0953 50.6713 24.3423 54.2188 24.4413 59.0203C24.4578 60.1093 23.5998 61.0168 22.5108 61.0498C22.4778 61.0003 22.4613 61.0003 22.4448 61.0003Z"
                    fill="white"
                  />
                  <path
                    d="M33.4669 53.955C32.3779 53.955 31.4869 53.064 31.4869 51.975V46.365C31.4869 45.111 30.7444 43.9725 29.5729 43.4775L19.1449 39.0225C18.1384 38.5935 17.6764 37.422 18.1054 36.432C18.5344 35.4255 19.7059 34.9635 20.6959 35.3925L31.1239 39.8475C33.7474 40.9695 35.4304 43.527 35.4304 46.3815V51.9915C35.4469 53.0805 34.5559 53.955 33.4669 53.955ZM44.5549 61.0005H44.5054C43.4164 60.984 42.5419 60.0765 42.5749 58.971C42.6739 54.1695 47.9209 50.622 51.7489 48.048C52.6234 47.454 53.4484 46.893 54.0259 46.4475C55.2964 45.4575 56.0389 43.527 56.0719 41.184V41.052L57.0784 27.8685C57.0784 27.5055 56.9299 27.1755 56.6659 26.9115C56.4514 26.697 56.1709 26.565 55.8739 26.5155C55.1974 26.8125 54.8179 27.819 54.8014 28.677V28.7925C54.7024 30.0795 54.1249 36.597 53.0854 38.9565C51.9634 41.481 46.8484 45.9195 45.8254 46.7775C45.0004 47.487 43.7464 47.388 43.0369 46.5465C42.3274 45.7215 42.4264 44.4675 43.2679 43.758C45.8584 41.547 48.9769 38.478 49.4719 37.356C50.0329 36.069 50.6269 31.4325 50.8579 28.5285C50.9404 25.608 52.7059 23.166 55.1809 22.5885C55.3129 22.5555 55.4614 22.539 55.5934 22.539C57.0619 22.506 58.4314 23.067 59.4709 24.09C60.5104 25.113 61.0714 26.499 61.0549 27.951V28.083L60.0484 41.283C59.9824 44.847 58.7284 47.784 56.4844 49.533C55.7914 50.0775 54.9169 50.6715 53.9764 51.2985C51.0394 53.2785 46.6009 56.265 46.5514 59.0205C46.5019 60.1425 45.6274 61.0005 44.5549 61.0005Z"
                    fill="white"
                  />
                  <path
                    d="M33.5331 53.9548C32.4441 53.9548 31.5531 53.0638 31.5531 51.9748V46.3648C31.5531 43.5103 33.2526 40.9528 35.8596 39.8308L46.2876 35.3758C47.2941 34.9468 48.4491 35.4088 48.8781 36.4153C49.3071 37.4218 48.8451 38.5768 47.8386 39.0058L37.4106 43.4608C36.2556 43.9558 35.4966 45.0943 35.4966 46.3483V51.9583C35.5131 53.0803 34.6221 53.9548 33.5331 53.9548ZM33.8631 31.5643C32.2791 31.5643 30.7941 30.9538 29.6556 29.8483L19.0626 19.5028C15.8451 16.3678 15.7791 11.1868 18.9141 7.95283C22.0326 4.75183 27.1806 4.65283 30.4146 7.73833L33.5991 10.7743L36.5196 7.78783C39.6711 4.57033 44.8686 4.47133 48.1356 7.58983C49.7526 9.12433 50.6601 11.2033 50.6931 13.4308C50.7261 15.6583 49.9011 17.7538 48.3336 19.3543L38.1531 29.7658C37.0311 30.9208 35.5296 31.5643 33.9126 31.5808C33.9126 31.5643 33.8961 31.5643 33.8631 31.5643ZM21.7686 10.7083C20.1516 12.3748 20.1846 15.0478 21.8511 16.6648L32.4441 27.0103C32.8236 27.3898 33.3351 27.5878 33.8796 27.5878H33.8961C34.4406 27.5878 34.9521 27.3568 35.3481 26.9773L45.5286 16.5658C46.3371 15.7408 46.7826 14.6353 46.7496 13.4803C46.7166 12.3253 46.2546 11.2363 45.4131 10.4443C43.7136 8.82733 41.0076 8.87683 39.3576 10.5433L33.7146 16.3183L27.6921 10.5928C26.0256 9.00883 23.3691 9.05833 21.7686 10.7083Z"
                    fill="white"
                  />
                </svg>
                <div class="line"></div>
                Service Portfolio
              </div>
              <div class="service-item item1">
                <div class="img-header">
                  <img src="../assets/portfolio/icon1.png" alt="" />
                </div>
                <div class="content">
                  <div class="title">Marketing</div>
                  <div class="desc">
                    We deliver end-to-end "marketing + sales" solution--from market insights to
                    campaigns, events, and CRM--driving sales and engagement.
                  </div>
                </div>
              </div>
              <div class="service-item item2">
                <div class="img-header">
                  <img src="../assets/portfolio/icon2.png" alt="" />
                </div>
                <div class="content">
                  <div class="title">Conference</div>
                  <div class="desc">
                    Uninet International Group provides all-in-one event solutions, from venue
                    sourcing to registration, check-in, badging, and mobile apps.
                  </div>
                </div>
              </div>
              <div class="service-item item3">
                <div class="img-header">
                  <img src="../assets/portfolio/icon3.png" alt="" />
                </div>
                <div class="content">
                  <div class="title">Online Trade Platform</div>
                  <div class="desc">
                    B2B: MatchupExpo.com streamlines global online trade by offering: Online
                    company/ product showcases, business matching, and order transactions Hybrid
                    (online + offline) exhibition solutions for organizers B2C: E-commerce Platform
                  </div>
                </div>
              </div>
              <div class="service-item item4">
                <div class="img-header">
                  <img src="../assets/portfolio/icon4.png" alt="" />
                </div>
                <div class="content">
                  <div class="title">Logistics & Compliance</div>
                  <div class="desc">Global logistics and customs clearance integrated services</div>
                </div>
              </div>
              <div class="service-item item5">
                <div class="img-header">
                  <img src="../assets/portfolio/icon5.png" alt="" />
                </div>
                <div class="content">
                  <div class="title">Real Estate Investment & Management</div>
                  <div class="desc">
                    Comprehensive real estate investment, development, and operational management
                    services
                  </div>
                </div>
              </div>
              <div class="service-item item6">
                <div class="img-header">
                  <img src="../assets/portfolio/icon6.png" alt="" />
                </div>
                <div class="content">
                  <div class="title">Exhibition & Event</div>
                  <div class="desc">
                    We leverages its expert team and streamlined operations to deliver end-to-end
                    solutions for large-scale exhibitions and conferences, serving government and
                    private sector clients worldwide.
                  </div>
                </div>
              </div>
              <div class="service-item item7">
                <div class="img-header">
                  <img src="../assets/portfolio/icon7.png" alt="" />
                </div>
                <div class="content">
                  <div class="title">Incentive & Travel</div>
                  <div class="desc">
                    Uninet International Group provides luxury custom itineraries including air
                    travel, top-tier hotels, and cultural exploration.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item == 'Advantages'" class="content-container">
          <h1>Advantages</h1>
          <div class="advantages">
            <div class="advantages-item item1">
              <div class="bg"></div>
              <div class="container">
                <div class="logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                  >
                    <path
                      d="M35.7906 20.5498C36.3582 21.2305 36.8117 22.0244 37.039 22.9325L44.0742 19.3013C45.2095 20.2094 46.6842 20.4367 48.0458 19.7559C49.8619 18.8478 50.5427 16.6924 49.6346 14.9904C48.7266 13.2873 46.5711 12.6065 44.7549 13.5146C44.1268 13.8203 43.6062 14.3093 43.2617 14.917C42.9173 15.5247 42.7653 16.2226 42.8257 16.9185L35.7906 20.5498ZM31.9331 18.3932C32.8226 18.5053 33.6755 18.8156 34.429 19.3013L38.0602 10.4511C39.5349 10.4511 41.0106 9.65611 41.6914 8.18145C41.9047 7.72878 42.024 7.23752 42.0419 6.73743C42.0598 6.23734 41.976 5.73881 41.7957 5.27203C41.6153 4.80525 41.3421 4.37993 40.9925 4.02183C40.643 3.66372 40.2244 3.38028 39.7622 3.18866C37.8329 2.39368 35.5633 3.18866 34.6563 5.11682C33.9755 6.70568 34.3159 8.40764 35.5633 9.42882L31.9331 18.3932ZM45.4357 25.7698L37.2663 24.2941V24.5214C37.2663 25.4294 37.039 26.2233 36.8117 26.9041L44.9811 28.3799C45.2095 29.9676 46.4569 31.2161 48.0458 31.6707C50.2023 32.2373 52.4709 30.8757 53.0386 28.7203C53.6062 26.5637 52.2447 24.4083 49.975 23.8406C48.1589 23.5002 46.3438 24.2941 45.4357 25.7698ZM23.9899 9.42882L27.5069 19.074C28.3019 18.6205 29.0958 18.2801 30.0039 18.167L26.4858 8.40765C28.1877 7.27337 28.9827 5.11682 28.3019 3.18866C27.5069 0.691723 24.7838 -0.555649 22.2869 0.238233C19.791 1.03212 18.3164 3.75525 19.1102 6.138C19.791 8.40765 21.8334 9.65611 23.9899 9.42882ZM28.3019 42.1098L30.7978 30.8768C29.8897 30.8768 28.9827 30.6484 28.1877 30.308L25.6919 41.5421C21.9476 41.3159 18.7698 43.9248 18.3153 47.6691C17.8618 51.5276 20.698 55.1589 24.5565 55.7265C28.5281 56.2942 32.0451 53.5711 32.6139 49.7126C32.9543 46.3087 31.1382 43.3582 28.3019 42.1098ZM7.8762 22.0244C10.5993 23.386 14.0033 22.5921 15.7052 20.2094L24.4434 23.6133C24.5565 22.7052 24.8969 21.9113 25.4646 21.1175L16.7275 17.7135C17.0679 15.3308 15.8194 12.8338 13.5498 11.5854C10.5993 10.1096 6.96812 11.1308 5.38036 14.0812C3.79149 16.9185 4.92577 20.4367 7.8762 22.0244ZM44.9822 38.4785L36.0178 28.2668C35.4449 28.9523 34.753 29.5288 33.9755 29.9687L42.9399 40.1805C42.1979 41.214 41.8475 42.4776 41.9513 43.7456C42.0551 45.0137 42.6063 46.2035 43.5065 47.1025C45.663 49.2591 49.1811 49.3722 51.4497 47.2156C53.6062 45.1733 53.8324 41.7694 51.5639 39.4997C49.7477 37.7978 47.0246 37.4574 44.9822 38.4785ZM25.9181 28.7203C25.3581 28.0327 24.8996 27.2684 24.5565 26.4506L14.2306 32.0111C12.1882 29.6283 8.55698 28.9476 5.72075 30.5353C2.42773 32.3515 1.18036 36.3231 3.10961 39.6139C4.92467 42.7905 9.12357 43.9259 12.4144 42.1098C15.3648 40.5209 16.6122 37.2301 15.591 34.2807L25.917 28.7203H25.9181Z"
                      fill="var(--color-primary)"
                    />
                  </svg>
                </div>
                <div class="title">Global Network & Local Expertise</div>
                <div class="content">
                  Five regional centers:
                  <br />
                  Singapore, HongKong, Nanjing, Lagos, Sao Paulo. Operates with multi-lingual teams
                  and collaborates closely with local government, associations and institutions.
                  Equipped with local cultural consultant teams
                </div>
              </div>
            </div>
            <div class="advantages-item item2">
              <div class="bg"></div>
              <div class="container">
                <div class="logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                  >
                    <path
                      d="M44.2748 27.9727L52.3604 19.8113C54.5459 17.6055 54.5459 14.0762 52.3604 12.0915L43.8377 3.48891C41.8708 1.5037 38.1555 1.5037 36.1886 3.48891L28.1029 11.6498L20.0173 3.48891C18.0504 1.5037 14.3356 1.5037 12.3687 3.48891L3.84549 12.0915C1.66004 14.2973 1.66004 17.8266 3.84549 19.8113L11.9311 27.9727L8.43442 31.2814C7.77879 31.9431 7.3417 32.6048 7.12315 33.4872L2.31568 46.9415C1.66004 48.7061 2.09713 50.4707 2.97131 51.7942C4.06403 53.1177 5.59334 54 7.34221 54C7.99784 54 8.43493 54 9.09056 53.7794L22.4213 48.9267C23.2955 48.7061 23.9511 48.2649 24.6067 47.6032L27.8849 44.2945L35.9706 52.4554C37.0633 53.5583 38.3746 53.9995 39.9044 53.9995C41.4342 53.9995 42.7454 53.3377 43.8382 52.4554L52.3609 43.8528C54.5464 41.6471 54.5464 38.1183 52.3609 36.1331L44.2748 27.9727ZM40.6312 6.13586C40.8497 6.13586 41.2868 6.35644 41.5053 6.35644L50.0281 14.959C50.4652 15.4002 50.4652 16.0619 50.0281 16.5026L46.9684 19.5907L36.9159 9.44455L39.9755 6.35644C39.975 6.35644 40.1936 6.13586 40.6312 6.13586ZM12.6584 22.017L16.5917 18.0466C17.2474 17.3849 17.2474 16.282 16.5917 15.6202C15.9361 14.9585 14.8434 14.9585 14.1877 15.6202L10.2544 19.5907L7.41336 16.7231C6.97627 16.282 6.97627 15.6202 7.41336 15.1791L15.9366 6.57702C16.1552 6.35644 16.3737 6.35644 16.8108 6.35644C17.2479 6.35644 17.4664 6.57702 17.685 6.57702L25.5526 14.7379L15.4995 24.8841L12.6584 22.017ZM22.2739 44.7357C22.2739 44.7357 22.0554 44.9562 21.8368 44.9562L8.50608 49.809C8.06899 50.0296 7.63191 49.809 7.41336 49.3678C7.19482 49.1473 7.19482 48.9267 7.19482 48.4855L12.0028 35.0307C12.0028 34.8101 12.2213 34.8101 12.2213 34.5895L34.5119 12.0915L44.5645 22.2376L40.1936 26.6492L27.0814 39.8829L22.2739 44.7357ZM49.8095 40.7658L41.2863 49.3678C40.8492 49.809 40.1936 49.809 39.7565 49.3678L36.9154 46.5008L40.8492 42.5304C41.5048 41.8687 41.5048 40.7658 40.8492 40.104C40.1936 39.4423 39.1008 39.4423 38.4452 40.104L34.5114 44.0744L31.6708 41.2069L41.7234 31.0603L49.8095 39.2217C50.2466 39.6629 50.2466 40.3241 49.8095 40.7658Z"
                      fill="var(--color-primary)"
                    />
                  </svg>
                </div>
                <div class="title">Customization Service</div>
                <div class="content">
                  The initial "three-dimensional demand analysis model" (business goals + user
                  experience + technology empowerment). Easy Ordering. Cost Certainty
                </div>
              </div>
            </div>
            <div class="advantages-item item3">
              <div class="bg"></div>
              <div class="container">
                <div class="logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_687_419)">
                      <path
                        d="M28.2611 52.6358L56.0216 23.5978L44.3166 3.83057H11.705L0 23.5978L27.6224 52.6358L27.9158 53.3609L28.2611 52.6358ZM27.9676 44.0038L20.1643 24.5473H35.7019L27.9676 44.0038ZM39.5 24.5473H50.4108L31.6966 44.0384L39.5 24.5473ZM42.3485 7.28336L50.5316 21.0945H39.5L33.9755 7.28336H42.3485ZM30.2637 7.28336L35.7882 21.0945H20.2506L25.7751 7.28336H30.2637ZM13.6731 7.28336H21.9598L16.4353 21.0945H5.52447L13.6731 7.28336ZM5.67985 24.5473H16.4353L24.2213 44.0211L5.67985 24.5473Z"
                        fill="var(--color-primary)"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_687_419">
                        <rect width="56" height="56" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="title">Professional & Experienced</div>
                <div class="content">
                  Over 120 exhibition projects worldwide annually, spanning 20+ industries in 30+
                  countries.
                  <br />
                  Around 25 years of experiences. Expert teams & partners located around the world
                </div>
              </div>
            </div>
            <div class="advantages-item item4">
              <div class="bg"></div>
              <div class="container">
                <div class="logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                  >
                    <path
                      d="M12.4 43.6H43.6V12.4H12.4V43.6ZM33.2 48.8H22.8V54H17.6V48.8H9.8C9.11044 48.8 8.44912 48.5261 7.96152 48.0385C7.47393 47.5509 7.2 46.8896 7.2 46.2V38.4H2V33.2H7.2V22.8H2V17.6H7.2V9.8C7.2 9.11044 7.47393 8.44912 7.96152 7.96152C8.44912 7.47393 9.11044 7.2 9.8 7.2H17.6V2H22.8V7.2H33.2V2H38.4V7.2H46.2C46.8896 7.2 47.5509 7.47393 48.0385 7.96152C48.5261 8.44912 48.8 9.11044 48.8 9.8V17.6H54V22.8H48.8V33.2H54V38.4H48.8V46.2C48.8 46.8896 48.5261 47.5509 48.0385 48.0385C47.5509 48.5261 46.8896 48.8 46.2 48.8H38.4V54H33.2V48.8ZM17.6 17.6H38.4V38.4H17.6V17.6Z"
                      fill="var(--color-primary)"
                    />
                  </svg>
                </div>
                <div class="title">Tech-Driven Innovation</div>
                <div class="content">
                  Independent Exhibition management System with IPR. Online Trade Platform.
                  Intelligent B2B Uninet System. Check-in & Check-out System. E-commerce Platform
                  Comprehensive Foreign Trade Service
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item == 'Success Fairs'" class="content-container">
          <h1>Success Fairs</h1>
          <div class="success-fairs">
            <Swiper
              :modules="[Autoplay]"
              :autoplay="{ delay: 5000 }"
              @slideChange="onSlideChange"
              @init="onSwiperInit"
            >
              <SwiperSlide class="fairs-swiper-item">
                <a class="fairs-item" href="https://www.homeshow-vietnam.com" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover1.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/homeshow.png" alt="" />
                    <div class="title">Home Show Vietnam</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      HCM City, Vietnam
                    </div>
                    <div class="since">
                      Since
                      <span>2023</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="https://www.vietnamhardwarefair.com" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover2.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/vhf.png" alt="" />
                    <div class="title">Hardware Fair Vietnam</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      HCM City, Vietnam
                    </div>
                    <div class="since">
                      Since
                      <span>2023</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="https://www.vietnamhardwarefair.com" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/VSF.jpg" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/vsf.png" alt="" />
                    <div class="title">Smart Factory Vietnam</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      HCM City, Vietnam
                    </div>
                    <div class="since">
                      Since
                      <span>2026</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="https://www.homeshowbrazil.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover3.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/baxi.png" alt="" />
                    <div class="title">Home Show Brazil</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      São Paulo, Brazil
                    </div>
                    <div class="since">
                      Since
                      <span>2018</span>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
              <SwiperSlide class="fairs-swiper-item">
                <a class="fairs-item"  href="https://www.gotexshow.com.br" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover11.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/gotex.png" alt="" />
                    <div class="title">GoTex Show</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      São Paulo, Brazil
                    </div>
                    <div class="since">
                      Since
                      <span>2013</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="https://www.autoequip-nigeria.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover4.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/autoequip.png" alt="" />
                    <div class="title">AutoEquip</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Lagos, Nigeria
                    </div>
                    <div class="since">
                      Since
                      <span>2017</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="https://www.homeshow-nigeria.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover5.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/homeshow.png" alt="" />
                    <div class="title">Home Show Nigeria</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Lagos, Nigeria
                    </div>
                    <div class="since">
                      Since
                      <span>2017</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="https://www.westafricatech.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover6.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/wam.png" alt="" />
                    <div class="title">WAM</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Lagos, Nigeria
                    </div>
                    <div class="since">
                      Since
                      <span>2017</span>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
              <SwiperSlide class="fairs-swiper-item">
                <a class="fairs-item" href="https://www.pvpower-nigeria.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover7.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/power.png" alt="" />
                    <div class="title">PV Power Nigeria</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Lagos, Nigeria
                    </div>
                    <div class="since">
                      Since
                      <span>2017</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="https://www.nigeriatex.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover13.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/ngtex.png" alt="" />
                    <div class="title">NigeriaTex</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Lagos, Nigeria
                    </div>
                    <div class="since">
                      Since
                      <span>2017</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="https://www.lifestyle-saudi.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover8.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/lifestyle.png" alt="" />
                    <div class="title">Lifestyle Saudi</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Riyadh, KSA
                    </div>
                    <div class="since">
                      Since
                      <span>2025</span>
                    </div>
                  </div>
                </a>
                <a class="fairs-item" href="http://www.intertex-saudi.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover9.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/intertex.png" alt="" />
                    <div class="title">Intertex Saudi</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Riyadh, KSA
                    </div>
                    <div class="since">
                      Since
                      <span>2025</span>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
              <SwiperSlide class="fairs-swiper-item" style="justify-content:flex-start">
              <a class="fairs-item" style="margin-right:20px" href="http://www.cptfair.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover10.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/cpt.png" alt="" />
                    <div class="title">CPT</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Cape Town, South Africa
                    </div>
                    <div class="since">
                      Since
                      <span>2016</span>
                    </div>
                  </div>
                </a>
              <a class="fairs-item" href="http://www.il-china.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover12.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/interiorlifestyle.png" alt="" />
                    <div class="title">Interiorlifestyle China</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Shanghai, China
                    </div>
                    <div class="since">
                      Since
                      <span>2007</span>
                    </div>
                  </div>
                </a>
                <!-- <a class="fairs-item" href="https://www.nigeriatex.com/" target="_blank">
                  <div class="tag">Annual</div>
                  <div class="cover">
                    <img src="../assets/fairs/cover13.png" alt="" />
                  </div>
                  <div class="content">
                    <img class="logo" src="../assets/fairs/ngtex.png" alt="" />
                    <div class="title">NigeriaTex</div>
                    <div class="addr">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.99622 1.54102C5.85757 1.54102 2.50619 4.73616 2.48828 8.7122C2.48828 10.14 2.92059 11.4993 3.72291 12.661L3.80148 12.771L3.84707 12.8454L3.88452 12.9015C3.90976 12.9379 3.93662 12.9727 3.96675 13.0071L3.98547 13.0271L8.75996 18.4845C8.91311 18.6594 9.10296 18.7997 9.31647 18.8958C9.52999 18.9919 9.76212 19.0414 9.99695 19.041C10.2318 19.0406 10.4637 18.9903 10.6769 18.8936C10.8901 18.7968 11.0795 18.6559 11.2321 18.4805L15.9805 13.0223L15.9492 13.0563C15.996 13.0082 16.0386 12.9562 16.0766 12.9011L16.1132 12.8458C16.1283 12.8226 16.1576 12.7738 16.1568 12.7754C16.9986 11.6193 17.4708 10.2104 17.4883 8.7254C17.4883 4.74497 14.1279 1.54102 9.99622 1.54102ZM9.99622 3.14119C13.2393 3.14119 15.86 5.63986 15.86 8.7158C15.849 9.84976 15.4827 10.9529 14.811 11.8749L14.7406 11.9846L9.99418 17.4412L5.21929 11.9838L5.17329 11.9089L5.14968 11.8749C4.47624 10.9547 4.11477 9.84935 4.11655 8.7158C4.1308 5.63346 6.74457 3.14119 9.99622 3.14119Z"
                          fill="#999999"
                        />
                        <path
                          d="M9.98819 5.70752C9.55045 5.70757 9.11701 5.79385 8.71261 5.96141C8.30821 6.12898 7.94078 6.37456 7.63129 6.68412C7.3218 6.99369 7.07631 7.36119 6.90885 7.76563C6.74138 8.17007 6.65522 8.60353 6.65527 9.04127C6.65533 9.47901 6.7416 9.91245 6.90917 10.3168C7.07673 10.7212 7.32231 11.0887 7.63188 11.3982C7.94145 11.7077 8.30894 11.9531 8.71338 12.1206C9.11782 12.2881 9.55128 12.3742 9.98902 12.3742C10.8731 12.3741 11.7209 12.0228 12.3459 11.3976C12.971 10.7724 13.3221 9.92449 13.3219 9.04044C13.3218 8.15638 12.9705 7.30858 12.3453 6.68354C11.7201 6.05849 10.8722 5.70741 9.98819 5.70752ZM9.98819 7.37398C10.4303 7.37409 10.8542 7.54981 11.1667 7.86249C11.4792 8.17517 11.6548 8.59919 11.6546 9.04127C11.6545 9.48335 11.4788 9.90728 11.1661 10.2198C10.8535 10.5323 10.4294 10.7078 9.98736 10.7077C9.54527 10.7076 9.12134 10.5319 8.80882 10.2192C8.4963 9.90654 8.32079 9.48252 8.3209 9.04044C8.32101 8.59835 8.49673 8.17442 8.80941 7.8619C9.12209 7.54938 9.54611 7.37387 9.98819 7.37398Z"
                          fill="#999999"
                        />
                      </svg>
                      Lagos, Nigeria
                    </div>
                    <div class="since">
                      Since
                      <span>2017</span>
                    </div>
                  </div>
                </a> -->
              </SwiperSlide>
            </Swiper>
            <div class="swiper-pagination">
              <div
                class="pagination-prev"
                :class="{ active: swiperActiveIndex != 0 }"
                @click="prevSlide"
              >
                <img v-if="swiperActiveIndex == 0" src="../assets/arrow.png" alt="" />
                <img v-else src="../assets/arrow-active.png" alt="" />
              </div>
              <div
                class="pagination-num"
                v-for="(_, index) in 4"
                :key="index"
                :class="{ active: index === swiperActiveIndex }"
                @click="goToSlide(index)"
              >
                {{ index + 1 }}
              </div>
              <div
                class="pagination-next"
                :class="{ active: swiperActiveIndex != 3 }"
                @click="nextSlide"
              >
                <img v-if="swiperActiveIndex == 3" src="../assets/arrow.png" alt="" />
                <img v-else src="../assets/arrow-active.png" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div v-if="item == 'Process'" class="Process">
          <div class="Process-detail">
            <!-- <div class="Process-how">How We Work</div> -->
            <div class="Process-Process">Process</div>
            <div class="Process-all-list">
              <div class="Process-list Process-list-left">
                <div
                  v-for="(item, index) in items"
                  :key="index"
                  @mouseenter="toggleItem(index)"
                  @mouseleave="activeIndex = -1"
                  :style="{
                    background: `linear-gradient(0deg, rgba(0, 23, 81, 0.90) 0%, rgba(0, 23, 81, 0.60) 45.5%, rgba(0, 23, 81, 0.00) 100%),url(${item.cover}) lightgray 50% / cover no-repeat`,
                  }"
                >
                  <div>{{ item.title }}</div>
                  <transition name="slide">
                    <div v-show="activeIndex === index" class="content">
                      {{ item.content }}
                    </div>
                  </transition>
                </div>
              </div>
              <!-- <div class="Process-list Process-list-right">
                <div v-for="(item, index) in items" :key="index" v-show="index == 2" @mouseenter="toggleItem(index)"
                  @mouseleave="activeIndex = -1" :style="{
                     background: `linear-gradient(0deg, rgba(0, 23, 81, 0.90) 0%, rgba(0, 23, 81, 0.60) 45.5%, rgba(0, 23, 81, 0.00) 100%),url(${item.cover}) lightgray 50% / cover no-repeat`
                  }">
                  <div> {{ item.title }}</div>
                  <transition name="slide">
                    <div v-show="activeIndex === index" class="content">
                      {{ item.content }}
                    </div>
                  </transition>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <div v-if="item == 'About Us'" class="aboutUs">
          <div class="aboutUs-detail">
            <!-- Why Choose Us -->
            <div class="aboutUs-why"></div>
            <div class="aboutUs-aboutUs">About Us</div>
            <div class="aboutUs-content">
              <div>
                An international network of
                <br />
                service partners and
                <br />
                customers
              </div>
              <div>
                Uninet International Group, a diversified and multi-national Corporation
                headquartered in Singapore. Since its founding in 2001, the Group has been a key
                member in the MICE industry, with successful expanding into strategic sectors, such
                as Digital Technology and Real Estate, etc.
                <div style="height: 10px"></div>
                Leveraging 25 years of continuous innovation, Uninet International Group has
                established a global business and partnership network, delivering cross-industry
                integrated solutions to international clients.

                <div class="title1">Global Reach:</div>
                <div class="title2">Service network:</div>
                Three-level Network: Headquarters + Regional Center + Local Partner
                <div class="title2">Global service:</div>
                Key Destinations: Singapore, China, Vietnam, Brazil, Nigeria, South Africa, Saudi
                Arabia, Hong Kong, etc.

                <div class="nums">
                  <div class="nums-grid">
                    <div class="grid-item">
                      <div>35%</div>
                      <div>Asia</div>
                    </div>
                    <div class="grid-item">
                      <div>20%</div>
                      <div>Africa</div>
                    </div>
                    <div class="grid-item">
                      <div>15%</div>
                      <div>Middle East</div>
                    </div>
                    <div class="grid-item">
                      <div>17%</div>
                      <div>South America</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item == 'Contact Us'" class="contactUs">
          <div class="contactUs-detail">
            <div class="contactUs-left">
              <div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <rect
                      x="11"
                      y="4"
                      width="13"
                      height="12"
                      rx="6"
                      fill="white"
                      fill-opacity="0.9"
                    />
                    <rect
                      x="6"
                      y="18"
                      width="23"
                      height="14"
                      rx="6"
                      fill="white"
                      fill-opacity="0.9"
                    />
                  </svg>
                </div>
                <div>
                  <div>+65 8788 2986</div>
                  <div>info@uninet-expo.com</div>
                </div>
              </div>
              <div>
                <div>Uninet</div>
                <p></p>
              </div>
              <div>
                Get the latest overseas exhibition participation strategy, and easily expand the
                international market!
              </div>
              <div>
                <div
                  v-for="(item, index) in [1, 2, 3, 4]"
                  :key="index + 'meid'"
                  @mouseenter="toggleItemMeid(index)"
                  @mouseleave="activeIndexMeid = -1"
                >
                  <!-- 1 -->
                  <svg
                    v-if="activeIndexMeid !== index && index == 0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M30.6673 15.9997C30.6673 25.4797 27.5607 29.6797 19.4007 30.5063C18.2707 30.6167 17.136 30.6701 16.0007 30.6663H14.5473C4.93398 30.2797 1.33398 26.213 1.33398 15.9997C1.33398 5.33301 5.33398 1.33301 16.0007 1.33301C26.6673 1.33301 30.6673 5.33301 30.6673 15.9997Z"
                      fill="#EEEEEE"
                    />
                    <path
                      d="M19.3995 14.0398V17.1464H23.8928L23.1861 21.7064H19.3995V30.5064C18.2695 30.6168 17.1348 30.6702 15.9995 30.6664H14.5461V21.7331H10.4395V17.1464H14.5461V13.7198C14.5052 12.89 14.6303 12.0604 14.9142 11.2797C15.1981 10.4989 15.6351 9.78275 16.1995 9.17311C18.5195 6.66645 23.9995 7.99978 23.9995 7.99978V11.8131H21.6261C21.0356 11.8131 20.4692 12.0477 20.0516 12.4653C19.634 12.8829 19.3995 13.4492 19.3995 14.0398Z"
                      fill="#797979"
                    />
                  </svg>

                  <svg
                    v-if="activeIndexMeid === index && index == 0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M30.6673 15.9997C30.6673 25.4797 27.5607 29.6797 19.4007 30.5063C18.2707 30.6167 17.136 30.6701 16.0007 30.6663H14.5473C4.93398 30.2797 1.33398 26.213 1.33398 15.9997C1.33398 5.33301 5.33398 1.33301 16.0007 1.33301C26.6673 1.33301 30.6673 5.33301 30.6673 15.9997Z"
                      fill="#FFD342"
                    />
                    <path
                      d="M19.3995 14.0398V17.1464H23.8928L23.1861 21.7064H19.3995V30.5064C18.2695 30.6168 17.1348 30.6702 15.9995 30.6664H14.5461V21.7331H10.4395V17.1464H14.5461V13.7198C14.5052 12.89 14.6303 12.0604 14.9142 11.2797C15.1981 10.4989 15.6351 9.78275 16.1995 9.17311C18.5195 6.66645 23.9995 7.99978 23.9995 7.99978V11.8131H21.6261C21.0356 11.8131 20.4692 12.0477 20.0516 12.4653C19.634 12.8829 19.3995 13.4492 19.3995 14.0398Z"
                      fill="black"
                      fill-opacity="0.5"
                    />
                  </svg>

                  <!-- 2 -->
                  <svg
                    v-if="activeIndexMeid !== index && index == 1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M30.6673 15.9997C30.6673 25.4797 27.5607 29.6797 19.4007 30.5063C18.2707 30.6167 17.136 30.6701 16.0007 30.6663H14.5473C4.93398 30.2797 1.33398 26.213 1.33398 15.9997C1.33398 5.33301 5.33398 1.33301 16.0007 1.33301C26.6673 1.33301 30.6673 5.33301 30.6673 15.9997Z"
                      fill="#EEEEEE"
                    />
                    <path d="M6.61328 12.293H10.7733V25.5196H6.61328V12.293Z" fill="#797979" />
                    <path
                      d="M8.69297 5.83984C9.16764 5.83984 9.63166 5.9806 10.0263 6.24432C10.421 6.50803 10.7286 6.88286 10.9103 7.3214C11.0919 7.75995 11.1395 8.24251 11.0469 8.70806C10.9542 9.17361 10.7257 9.60125 10.39 9.9369C10.0544 10.2725 9.62674 10.5011 9.16119 10.5937C8.69563 10.6863 8.21307 10.6388 7.77453 10.4572C7.33599 10.2755 6.96116 9.96789 6.69744 9.57321C6.43373 9.17853 6.29297 8.71452 6.29297 8.23984C6.29297 7.60332 6.54583 6.99287 6.99591 6.54279C7.446 6.0927 8.05645 5.83984 8.69297 5.83984Z"
                      fill="#797979"
                    />
                    <path
                      d="M20.8662 12.293C20.135 12.3284 19.4191 12.5164 18.7648 12.8447C18.1104 13.1731 17.5318 13.6346 17.0662 14.1996V12.293H12.9062V25.5196H17.0662V17.9863C17.0662 17.6921 17.1242 17.4009 17.2368 17.1291C17.3493 16.8573 17.5143 16.6104 17.7223 16.4024C17.9303 16.1944 18.1773 16.0294 18.449 15.9168C18.7208 15.8042 19.0121 15.7463 19.3062 15.7463C19.6004 15.7463 19.8917 15.8042 20.1635 15.9168C20.4352 16.0294 20.6822 16.1944 20.8902 16.4024C21.0982 16.6104 21.2632 16.8573 21.3757 17.1291C21.4883 17.4009 21.5462 17.6921 21.5462 17.9863V25.5196H25.7063V18.4263C25.7063 15.093 25.3329 12.293 20.8662 12.293Z"
                      fill="#797979"
                    />
                  </svg>

                  <svg
                    v-if="activeIndexMeid === index && index == 1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M30.6673 15.9997C30.6673 25.4797 27.5607 29.6797 19.4007 30.5063C18.2707 30.6167 17.136 30.6701 16.0007 30.6663H14.5473C4.93398 30.2797 1.33398 26.213 1.33398 15.9997C1.33398 5.33301 5.33398 1.33301 16.0007 1.33301C26.6673 1.33301 30.6673 5.33301 30.6673 15.9997Z"
                      fill="#FFD342"
                    />
                    <path
                      d="M6.61328 12.293H10.7733V25.5196H6.61328V12.293Z"
                      fill="black"
                      fill-opacity="0.5"
                    />
                    <path
                      d="M8.69297 5.83984C9.16764 5.83984 9.63166 5.9806 10.0263 6.24432C10.421 6.50803 10.7286 6.88286 10.9103 7.3214C11.0919 7.75995 11.1395 8.24251 11.0469 8.70806C10.9542 9.17361 10.7257 9.60125 10.39 9.9369C10.0544 10.2725 9.62674 10.5011 9.16119 10.5937C8.69563 10.6863 8.21307 10.6388 7.77453 10.4572C7.33599 10.2755 6.96116 9.96789 6.69744 9.57321C6.43373 9.17853 6.29297 8.71452 6.29297 8.23984C6.29297 7.60332 6.54583 6.99287 6.99591 6.54279C7.446 6.0927 8.05645 5.83984 8.69297 5.83984Z"
                      fill="black"
                      fill-opacity="0.5"
                    />
                    <path
                      d="M20.8662 12.293C20.135 12.3284 19.4191 12.5164 18.7648 12.8447C18.1104 13.1731 17.5318 13.6346 17.0662 14.1996V12.293H12.9062V25.5196H17.0662V17.9863C17.0662 17.6921 17.1242 17.4009 17.2368 17.1291C17.3493 16.8573 17.5143 16.6104 17.7223 16.4024C17.9303 16.1944 18.1773 16.0294 18.449 15.9168C18.7208 15.8042 19.0121 15.7463 19.3062 15.7463C19.6004 15.7463 19.8917 15.8042 20.1635 15.9168C20.4352 16.0294 20.6822 16.1944 20.8902 16.4024C21.0982 16.6104 21.2632 16.8573 21.3757 17.1291C21.4883 17.4009 21.5462 17.6921 21.5462 17.9863V25.5196H25.7063V18.4263C25.7063 15.093 25.3329 12.293 20.8662 12.293Z"
                      fill="black"
                      fill-opacity="0.5"
                    />
                  </svg>

                  <!-- 3 -->
                  <svg
                    v-if="activeIndexMeid !== index && index == 2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M30.6673 15.9997C30.6673 25.4797 27.5607 29.6797 19.4007 30.5063C18.2707 30.6167 17.136 30.6701 16.0007 30.6663H14.5473C4.93398 30.2797 1.33398 26.213 1.33398 15.9997C1.33398 5.33301 5.33398 1.33301 16.0007 1.33301C26.6673 1.33301 30.6673 5.33301 30.6673 15.9997Z"
                      fill="#EEEEEE"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.8273 24.9512H25.7832L18.4527 15.2645L24.6373 8H21.8884L17.1591 13.5551L12.9552 8H6.99939L14.006 17.2587L7.457 24.9512H10.2058L15.2996 18.9681L19.8273 24.9512ZM16.5162 17.539L20.7387 23.1187H22.0982L17.236 16.6936L16.5162 17.539ZM15.9424 14.9842L12.0439 9.83256H10.6844L15.2227 15.8296L15.9424 14.9842Z"
                      fill="black"
                      fill-opacity="0.5"
                    />
                  </svg>

                  <svg
                    v-if="activeIndexMeid === index && index == 2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M30.6673 15.9997C30.6673 25.4797 27.5607 29.6797 19.4007 30.5063C18.2707 30.6167 17.136 30.6701 16.0007 30.6663H14.5473C4.93398 30.2797 1.33398 26.213 1.33398 15.9997C1.33398 5.33301 5.33398 1.33301 16.0007 1.33301C26.6673 1.33301 30.6673 5.33301 30.6673 15.9997Z"
                      fill="#FFD342"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.8273 24.9512H25.7832L18.4527 15.2645L24.6373 8H21.8884L17.1591 13.5551L12.9552 8H6.99939L14.006 17.2587L7.457 24.9512H10.2058L15.2996 18.9681L19.8273 24.9512ZM16.5162 17.539L20.7387 23.1187H22.0982L17.236 16.6936L16.5162 17.539ZM15.9424 14.9842L12.0439 9.83256H10.6844L15.2227 15.8296L15.9424 14.9842Z"
                      fill="black"
                      fill-opacity="0.5"
                    />
                  </svg>

                  <!-- 4 -->
                  <svg
                    v-if="activeIndexMeid !== index && index == 3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M1.33398 15.9997C1.33398 5.33301 5.33398 1.33301 16.0007 1.33301C26.6673 1.33301 30.6673 5.33301 30.6673 15.9997C30.6673 26.6663 26.6673 30.6663 16.0007 30.6663C5.33398 30.6663 1.33398 26.6663 1.33398 15.9997Z"
                      fill="#EEEEEE"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.3333 24.6933H19.3467C20.0482 24.6933 20.7428 24.5549 21.3907 24.2861C22.0387 24.0172 22.6272 23.6232 23.1226 23.1265C23.618 22.6299 24.0106 22.0403 24.2779 21.3917C24.5451 20.7431 24.6818 20.0482 24.68 19.3467V12.3333C24.68 10.9188 24.1181 9.56229 23.1179 8.5621C22.1177 7.5619 20.7612 7 19.3467 7H12.3333C10.9188 7 9.56229 7.5619 8.5621 8.5621C7.5619 9.56229 7 10.9188 7 12.3333V19.36C7 20.7745 7.5619 22.131 8.5621 23.1312C9.56229 24.1314 10.9188 24.6933 12.3333 24.6933ZM9.76335 9.76335C10.4452 9.08147 11.369 8.69685 12.3333 8.69333H19.3467C20.311 8.69685 21.2348 9.08147 21.9167 9.76335C22.5985 10.4452 22.9832 11.369 22.9867 12.3333V19.3467C22.9832 20.311 22.5985 21.2348 21.9167 21.9167C21.2348 22.5985 20.311 22.9832 19.3467 22.9867H12.3333C11.369 22.9832 10.4452 22.5985 9.76335 21.9167C9.08147 21.2348 8.69685 20.311 8.69333 19.3467V12.3333C8.69685 11.369 9.08147 10.4452 9.76335 9.76335ZM21.7329 11.0134C21.7329 11.2244 21.6704 11.4306 21.5532 11.6061C21.436 11.7815 21.2694 11.9182 21.0745 11.9989C20.8796 12.0796 20.6651 12.1008 20.4582 12.0596C20.2513 12.0185 20.0612 11.9169 19.912 11.7677C19.7629 11.6185 19.6613 11.4285 19.6201 11.2215C19.5789 11.0146 19.6001 10.8002 19.6808 10.6052C19.7615 10.4103 19.8983 10.2437 20.0737 10.1265C20.2491 10.0093 20.4553 9.94678 20.6663 9.94678C20.8088 9.95064 20.9492 9.98234 21.0796 10.0401C21.2717 10.1208 21.4359 10.256 21.552 10.429C21.6681 10.602 21.731 10.8051 21.7329 11.0134ZM15.8392 20.2935H15.5992C14.5045 20.2242 13.4726 19.7581 12.6969 18.9825C11.9212 18.2068 11.4551 17.1749 11.3859 16.0801C11.3519 15.4753 11.442 14.87 11.6507 14.3013C11.8593 13.7327 12.1821 13.2127 12.5992 12.7735C13.0229 12.3462 13.5279 12.008 14.0844 11.779C14.6408 11.55 15.2375 11.4348 15.8392 11.4401C16.5683 11.4396 17.2863 11.618 17.9302 11.9597C18.5742 12.3015 19.1244 12.7961 19.5326 13.4001C20.0239 14.1193 20.2887 14.9691 20.2926 15.8401C20.2979 16.4418 20.1827 17.0385 19.9537 17.595C19.7247 18.1515 19.3865 18.6564 18.9592 19.0801C18.1166 19.8749 16.9975 20.3102 15.8392 20.2935ZM15.8392 13.0935C15.4732 13.1054 15.1132 13.1901 14.7803 13.3425C14.4473 13.495 14.148 13.7122 13.8998 13.9815C13.6516 14.2508 13.4595 14.5668 13.3346 14.911C13.2098 15.2553 13.1547 15.621 13.1726 15.9868C13.2079 16.6614 13.4918 17.299 13.9694 17.7766C14.4471 18.2543 15.0847 18.5381 15.7592 18.5735C16.125 18.5823 16.4889 18.5183 16.8298 18.3853C17.1706 18.2522 17.4816 18.0527 17.7446 17.7984C18.0076 17.544 18.2175 17.2399 18.3619 16.9037C18.5063 16.5675 18.5825 16.206 18.5859 15.8401C18.5808 15.2948 18.4188 14.7625 18.1192 14.3068C17.8661 13.9348 17.5263 13.6299 17.1291 13.4185C16.7319 13.2071 16.2892 13.0956 15.8392 13.0935Z"
                      fill="#797979"
                    />
                  </svg>

                  <svg
                    v-if="activeIndexMeid === index && index == 3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M1.33398 15.9997C1.33398 5.33301 5.33398 1.33301 16.0007 1.33301C26.6673 1.33301 30.6673 5.33301 30.6673 15.9997C30.6673 26.6663 26.6673 30.6663 16.0007 30.6663C5.33398 30.6663 1.33398 26.6663 1.33398 15.9997Z"
                      fill="#FFD342"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.3333 24.6933H19.3467C20.0482 24.6933 20.7428 24.5549 21.3907 24.2861C22.0387 24.0172 22.6272 23.6232 23.1226 23.1265C23.618 22.6299 24.0106 22.0403 24.2779 21.3917C24.5451 20.7431 24.6818 20.0482 24.68 19.3467V12.3333C24.68 10.9188 24.1181 9.56229 23.1179 8.5621C22.1177 7.5619 20.7612 7 19.3467 7H12.3333C10.9188 7 9.56229 7.5619 8.5621 8.5621C7.5619 9.56229 7 10.9188 7 12.3333V19.36C7 20.7745 7.5619 22.131 8.5621 23.1312C9.56229 24.1314 10.9188 24.6933 12.3333 24.6933ZM9.76335 9.76335C10.4452 9.08147 11.369 8.69685 12.3333 8.69333H19.3467C20.311 8.69685 21.2348 9.08147 21.9167 9.76335C22.5985 10.4452 22.9832 11.369 22.9867 12.3333V19.3467C22.9832 20.311 22.5985 21.2348 21.9167 21.9167C21.2348 22.5985 20.311 22.9832 19.3467 22.9867H12.3333C11.369 22.9832 10.4452 22.5985 9.76335 21.9167C9.08147 21.2348 8.69685 20.311 8.69333 19.3467V12.3333C8.69685 11.369 9.08147 10.4452 9.76335 9.76335ZM21.7329 11.0134C21.7329 11.2244 21.6704 11.4306 21.5532 11.6061C21.436 11.7815 21.2694 11.9182 21.0745 11.9989C20.8796 12.0796 20.6651 12.1008 20.4582 12.0596C20.2513 12.0185 20.0612 11.9169 19.912 11.7677C19.7629 11.6185 19.6613 11.4285 19.6201 11.2215C19.5789 11.0146 19.6001 10.8002 19.6808 10.6052C19.7615 10.4103 19.8983 10.2437 20.0737 10.1265C20.2491 10.0093 20.4553 9.94678 20.6663 9.94678C20.8088 9.95064 20.9492 9.98234 21.0796 10.0401C21.2717 10.1208 21.4359 10.256 21.552 10.429C21.6681 10.602 21.731 10.8051 21.7329 11.0134ZM15.8392 20.2935H15.5992C14.5045 20.2242 13.4726 19.7581 12.6969 18.9825C11.9212 18.2068 11.4551 17.1749 11.3859 16.0801C11.3519 15.4753 11.442 14.87 11.6507 14.3013C11.8593 13.7327 12.1821 13.2127 12.5992 12.7735C13.0229 12.3462 13.5279 12.008 14.0844 11.779C14.6408 11.55 15.2375 11.4348 15.8392 11.4401C16.5683 11.4396 17.2863 11.618 17.9302 11.9597C18.5742 12.3015 19.1244 12.7961 19.5326 13.4001C20.0239 14.1193 20.2887 14.9691 20.2926 15.8401C20.2979 16.4418 20.1827 17.0385 19.9537 17.595C19.7247 18.1515 19.3865 18.6564 18.9592 19.0801C18.1166 19.8749 16.9975 20.3102 15.8392 20.2935ZM15.8392 13.0935C15.4732 13.1054 15.1132 13.1901 14.7803 13.3425C14.4473 13.495 14.148 13.7122 13.8998 13.9815C13.6516 14.2508 13.4595 14.5668 13.3346 14.911C13.2098 15.2553 13.1547 15.621 13.1726 15.9868C13.2079 16.6614 13.4918 17.299 13.9694 17.7766C14.4471 18.2543 15.0847 18.5381 15.7592 18.5735C16.125 18.5823 16.4889 18.5183 16.8298 18.3853C17.1706 18.2522 17.4816 18.0527 17.7446 17.7984C18.0076 17.544 18.2175 17.2399 18.3619 16.9037C18.5063 16.5675 18.5825 16.206 18.5859 15.8401C18.5808 15.2948 18.4188 14.7625 18.1192 14.3068C17.8661 13.9348 17.5263 13.6299 17.1291 13.4185C16.7319 13.2071 16.2892 13.0956 15.8392 13.0935Z"
                      fill="black"
                      fill-opacity="0.5"
                    />
                  </svg>

                  <!-- <img v-show="activeIndexMeid === index" src="@/assets/simp1.png" alt="">
                  <img v-show="activeIndexMeid !== index" src="@/assets/simp2.png" alt=""> -->
                </div>
              </div>
              <img src="@/assets/new-top-logo.png" alt="" />
            </div>
            <div class="contactUs-mid" style="cursor: pointer">
              <div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.26 33C17.26 33 28.28 21.1062 28.28 15.02C28.28 8.93382 23.3462 4 17.26 4C11.1738 4 6.23999 8.93382 6.23999 15.02C6.23999 21.1062 17.26 33 17.26 33ZM17.26 19.08C19.5022 19.08 21.32 17.2623 21.32 15.02C21.32 12.7777 19.5022 10.96 17.26 10.96C15.0177 10.96 13.2 12.7777 13.2 15.02C13.2 17.2623 15.0177 19.08 17.26 19.08Z"
                      fill="white"
                      fill-opacity="0.9"
                    />
                  </svg>
                </div>
                <div>
                  <div>989 SERANGOON ROAD</div>
                  <div>#01-01 SINGAPORE</div>
                </div>
              </div>
              <div>
                <div>Services</div>
                <p></p>
              </div>
              <div @click="scrollToSection(0)">Marketing</div>
              <div @click="scrollToSection(1)">Incentive</div>
              <div @click="scrollToSection(2)">Conference</div>
              <div @click="scrollToSection(3)">Exhibition</div>
            </div>
            <div class="contactUs-right">
              <div class="contactus-right-title">
                <span>Get</span>
                <span>■</span>
                <span>in</span>
                <span>■</span>
                <span>Touch</span>
              </div>
              <!-- <submitFrom></submitFrom> -->
              <emailJs></emailJs>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 底部 -->
    <!-- <footer class="footer">
      <p>© 2025 Uninet</p>
    </footer> -->
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import Carousel from './carousel.vue';
// import accordion from './accordion.vue';
// import submitFrom from './submitFrom.vue';
import emailJs from './email-js.vue';
const isScrolled = ref(false);
const currentSection = ref(0);
const sections = ref([]);
const navItems = ref([
  'Marketing',
  'Incentive',
  'Conference',
  'Exhibition',
  'Service Portfolio',
  'Advantages',
  'Process',
  'Success Fairs',
  'About Us',
  'Contact Us',
]);
// import image from '@/assets/banner.png';
// import footerBg from '@/assets/footer-bg.png';

import swiper1 from '@/assets/swiper1.png';
import swiper2 from '@/assets/swiper2.png';
import swiper3 from '@/assets/swiper3.png';

import process1 from '@/assets/process1.png';
import process2 from '@/assets/process2.png';
// import process3 from '@/assets/process3.png';
import process4 from '@/assets/process4.png';
const images = [
  {
    large: swiper1,
    small: swiper1,
    alt: 'Description 1',
  },
  {
    large: swiper2,
    small: swiper2,
    alt: 'Description 2',
  },
  {
    large: swiper3,
    small: swiper3,
    alt: 'Description 3',
  },
];

const items = [
  // { cover: process1, title: 'Comprehensive Business Discovery', content: 'When planning an event, choosing the right venue is key. Lean in, we’ve got the local scoop and will help you find the best fit faster. From creative menu ideation to innovative, progressive courses or dine-arounds with a local twist, we cater to groups of all sizes and cuisine interests.' },
  {
    cover: process2,
    title: 'Creative Event Concepting & Design',
    content:
      'Every event starts with an idea. We deliver stunning concepts and cutting-edge themes with every detail in mind, from the moment guests arrive to the final farewell!',
  },
  {
    cover: process1,
    title: 'Detailed Event Planning & Logistics',
    content:
      'Whether it is designing the perfect stage backdrop or illuminating the event with stunning lighting and cohesive sound, we focus on the overall impact and take every detail into account.',
  },
  {
    cover: process4,
    title: 'Seamless Onsite Delivery',
    content:
      'Our experienced event managers come prepared, consider the contingencies, communicate transparently, and work side-by-side with vetted vendors to make the magic happen!',
  },
];

const activeIndex = ref(-1);

const toggleItem = (index) => {
  activeIndex.value = index;
};

const activeIndexMeid = ref(-1);

const toggleItemMeid = (index) => {
  activeIndexMeid.value = index;
};

const handleScroll = () => {
  // 检测滚动距离
  isScrolled.value = window.scrollY > 50;
  // 检测当前所在区块
  const scrollPosition = window.scrollY + 100;
  sections.value.forEach((section, index) => {
    if (!section) return;
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
      currentSection.value = index;
    }
  });
};

const scrollToSection = (index) => {
  const section = sections.value[index];
  if (section) {
    window.scrollTo({
      top: section.offsetTop - 80,
      behavior: 'smooth',
    });
    currentSection.value = index;
  }
};

const swiperActiveIndex = ref(0);
const _swiper = ref(null);

const onSwiperInit = (swiper) => {
  _swiper.value = swiper;
};

const onSlideChange = (swiper) => {
  const activeIndex = swiper.activeIndex;
  swiperActiveIndex.value = activeIndex;
};

const goToSlide = (index) => {
  _swiper.value.slideTo(index);
};

const prevSlide = () => {
  if (swiperActiveIndex.value === 0) {
    _swiper.value.slideTo(3);
  } else {
    _swiper.value.slidePrev();
  }
};

const nextSlide = () => {
  if (swiperActiveIndex.value === 3) {
    _swiper.value.slideTo(0);
  } else {
    _swiper.value.slideNext();
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  padding-top: 80px;
}

/* 头部样式 */
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;
  color: white;
  display: flex;
  justify-content: center;

  .header-content {
    display: flex;
    align-items: center;
    gap: 68px;
    margin: 0 auto;
    padding: 30px 10px;

    .logo {
      font-size: 24px;
      font-weight: 700;
    }

    .nav {
      display: flex;
      gap: 44px;
    }
  }
}

.nav-item {
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s;
  position: relative;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}

.nav-item.active {
  color: #fff;
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;

  padding-bottom: 10px;
  border-bottom: 2px solid #fff;
}

.scrolled .nav-item {
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s;
  position: relative;
  color: #666;
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}

.scrolled .nav-item.active {
  color: #10418a;
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;

  padding-bottom: 10px;
  border-bottom: 2px solid #10418a;
}

/* 滚动后样式 */
.scrolled {
  background: white !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  color: #333;
}

.scrolled .header-content {
  padding: 27px 10px;
}

/* 内容区块 */
.content-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(45deg, #f5f7fa, #c3cfe2);
  .content-container {
    padding: 80px 0;
    width: 100%;
    background-color: #fff;
    &.service-bg {
      background-image: url(../assets/service-bg.jpg);
      background-repeat: no-repeat;
      background-size: cover;
    }
    > h1 {
      color: #212121;
      font-size: 40px;
      font-weight: 700;
      line-height: 60px;
    }
    .sub-title {
      color: #212121;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      max-width: 874px;
      margin: 0 auto;
    }
    .service-portfolio {
      margin: 40px auto 0;
      width: 1200px;
      height: 648px;
      position: relative;
      .service-ring {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 396px;
        height: 396px;
        border-radius: 396px;
        background: radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0) 75%, #fff 100%);
        .service-ring-bg {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 282px;
          height: 282px;
          background-image: url(../assets/portfolio/ring-bg.png);
          background-repeat: no-repeat;
          background-size: cover;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          color: #fff;
          text-align: center;
          font-size: 30px;
          font-weight: 600;
          line-height: 36px;
          .line {
            width: 30px;
            height: 3px;
            background: #fff;
          }
        }
        .service-item {
          position: absolute;
          .img-header {
            width: 60px;
            height: 60px;
            > img {
              width: 100%;
              height: 100%;
            }
          }
          .content {
            position: absolute;
            .title {
              color: var(--color-primary);
              font-size: 20px;
              font-weight: 600;
              line-height: 30px;
            }
            .desc {
              color: #666;
              font-size: 14px;
              font-weight: 300;
              line-height: 21px;
            }
          }
          &.item1 {
            left: 130px;
            top: -26px;
            .content {
              left: -190px;
              top: -100px;
              width: 446px;
            }
          }
          &.item2 {
            left: 304px;
            top: 24px;
            .content {
              left: 68px;
              top: 0px;
              width: 400px;
              text-align: left;
            }
          }
          &.item3 {
            left: 364px;
            top: 180px;
            .content {
              left: 68px;
              top: -20px;
              width: 358px;
              text-align: left;
            }
          }
          &.item4 {
            left: 298px;
            top: 316px;
            .content {
              left: 0;
              top: 100%;
              width: 400px;
              text-align: left;
            }
          }
          &.item5 {
            left: 140px;
            top: 362px;
            .content {
              left: -338px;
              top: 100%;
              width: 437px;
              text-align: right;
            }
          }
          &.item6 {
            left: 0;
            top: 272px;
            .content {
              left: -352px;
              top: -20px;
              width: 346px;
              text-align: right;
            }
          }
          &.item7 {
            left: -8px;
            top: 80px;
            .content {
              left: -350px;
              top: -14px;
              width: 343px;
              text-align: right;
            }
          }
        }
      }
    }
    .advantages {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      .advantages-item {
        position: relative;
        padding: 50px 40px;
        box-sizing: border-box;
        max-width: 300px;
        cursor: pointer;
        &:hover {
          .bg {
            height: 100%;
          }
          .container {
            .logo {
              svg {
                path {
                  fill: #fff;
                }
              }
            }
            .title {
              color: #fff;
            }
            .content {
              color: #fff;
            }
          }
        }
        &.item1 {
          .bg {
            background-image: url(../assets/advantage/bg1.jpg);
          }
        }
        &.item2 {
          .bg {
            background-image: url(../assets/advantage/bg2.jpg);
          }
        }
        &.item3 {
          .bg {
            background-image: url(../assets/advantage/bg3.jpg);
          }
        }
        &.item4 {
          .bg {
            background-image: url(../assets/advantage/bg4.jpg);
          }
        }
        .bg {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 0;
          overflow: hidden;
          transition: all 0.3s;
          background-repeat: no-repeat;
        }
        .container {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          gap: 20px;
          .logo {
            svg {
              path {
                transition: all 0.3s;
              }
            }
          }
          .title {
            color: #212121;
            text-align: center;
            font-size: 20px;
            font-weight: 500;
            line-height: 28px;
            transition: all 0.3s;
          }
          .content {
            color: #666;
            text-align: center;
            font-size: 14px;
            font-weight: 300;
            line-height: 21px;
            transition: all 0.3s;
          }
        }
      }
    }
    .success-fairs {
      margin: 40px auto 0;
      width: 1200px;
      .fairs-swiper-item {
        display: flex;
        justify-content: space-between;
        .fairs-item {
          width: 284px;
          background: #fafafa;
          text-decoration: none;
          position: relative;
          &:hover {
            .cover {
              > img {
                transform: scale(1.2);
              }
            }
          }
          .tag {
            position: absolute;
            left: 0;
            top: 6px;
            padding: 0 9px;
            border-radius: 0 26px 26px 0;
            background: rgba(0, 0, 0, 0.6);
            line-height: 24px;
            color: #fff;
            font-size: 16px;
            font-weight: 400;
            z-index: 1;
          }
          .cover {
            width: 100%;
            height: 180px;
            overflow: hidden;
            > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: all 0.3s;
            }
          }
          .content {
            padding: 20px 20px 30px;
            text-align: left;
            .logo {
              height: 28px;
              object-fit: contain;
            }
            .title {
              margin: 4px 0;
              color: #212121;
              font-size: 20px;
              font-weight: 600;
              line-height: 30px;
            }
            .addr {
              color: #212121;
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              display: flex;
              align-items: center;
              gap: 6px;
            }
            .since {
              margin-top: 26px;
              color: #999;
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              > span {
                margin-left: 8px;
                color: #212121;
                font-size: 18px;
                font-weight: 500;
              }
            }
          }
        }
      }
      .swiper-pagination {
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 22px;
        .pagination-num {
          color: #212121;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          cursor: pointer;
          &.active {
            color: var(--color-primary);
          }
        }
        .pagination-prev,
        .pagination-next {
          width: 40px;
          height: 40px;
          background: #fff;
          box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &.active {
            background: var(--color-primary);
            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
          }
        }
        .pagination-next {
          transform: rotate(180deg);
        }
      }
    }
  }
}

.content-section:nth-child(odd) {
  background: linear-gradient(45deg, #ffffff, #f8f9fa);
}

/* marketing */
.marketing {
  background: url('@/assets/banner.png');
  height: 826px;
  width: 100%;
  background-size: cover;

  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}

.marketing-name {
  color: #fff;
  font-family: Arial;
  font-size: 76px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  /* 91.2px */
  /* margin-top: -40px; */
}

.marketing-border {
  width: 110px;
  height: 6px;
  background: #8f6e00;
  margin-top: 30px;
}

.marketing-cont {
  color: #fff;
  text-align: center;
  font-family: 'Arial';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: absolute;
  bottom: 220px;
}

/* business */
.business {
  width: 100%;
  background: #10338a;

  display: flex;
  align-items: center;

  padding: 40px 0;
}

.business-cont {
  max-width: 1200px;
  margin: 0 auto;

  display: flex;
  align-items: center;
}

.business .title {
  color: #fff;
  font-family: Arial;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  /* 52px */

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding-left: 24px;
  border-left: 6px solid #fff;
  padding-right: 170px;
}

.business .cont {
  color: #fff;
  text-align: justify;
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  padding: 48px 48px;
  /* 24px */
}

/* incentive */
.incentive {
  width: 100%;
  background: #fff;
  padding: 80px 0;

  .incentive-detail {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;

    .incentive-detail-left {
      padding: 48px 60px 48px 0;

      > div:nth-child(1) {
        color: #8f6e00;
        font-family: Arial;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        text-align: left;
        /* 24px */
      }

      > div:nth-child(2) {
        color: #212121;
        font-family: Arial;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        text-align: left;
        /* 60px */
      }

      > div:nth-child(3) {
        margin-top: 40px;

        color: #212121;
        font-family: Arial;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 150%;
        /* 24px */
        text-align: left;
      }
    }
  }
}

// incentive-services
.incentive-services {
  width: 100%;
  // background: url('@/assets/incentive.png');
  height: 664px;

  background: linear-gradient(
      90deg,
      rgba(0, 23, 81, 0.9) 0%,
      rgba(0, 23, 81, 0.6) 45.5%,
      rgba(0, 23, 81, 0) 100%
    ),
    url('@/assets/incentive.png') lightgray 0px -431.145px / 100% 229.419% no-repeat;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .services-detail {
    width: 1200px;
    margin: 0 auto;

    .services-title {
      margin-top: 40px;
      text-align: left;
      margin-bottom: 30px;

      color: #fff;
      font-family: Arial;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      /* 48px */
    }
  }
}

// conference
.conference {
  width: 100%;
  background: #fafafa;
  padding: 80px 0;

  .conference-detail {
    width: 1200px;
    margin: 0 auto;

    .conference-keep {
      color: #8f6e00;
      text-align: center;
      font-family: Arial;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      /* 24px */
      text-transform: capitalize;
    }

    .conference-con {
      color: #212121;
      font-family: Arial;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      /* 60px */
    }

    .conference-cont {
      display: flex;
      gap: 20px;
      margin-top: 40px;

      image {
        width: 588px;
        height: 606px;
      }

      .conference-cont-right {
        > div {
          padding: 20px 0 20px 40px;

          > div:nth-child(1) {
            color: #212121;
            font-family: Arial;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 130%;
            /* 26px */
            margin-bottom: 16px;
            text-align: left;
          }

          > div:nth-child(2) {
            color: #666;
            font-family: Arial;
            font-size: 16px;
            font-style: normal;
            font-weight: 300;
            line-height: 150%;
            /* 24px */
            text-align: left;
          }
        }
      }
    }
  }
}

// exhibition
.exhibition {
  width: 100%;
  background-color: #ffd342;
  padding: 80px 0;

  .exhibition-detail {
    width: 1200px;
    margin: 0 auto;

    .exhibition-service {
      color: #7b5e00;
      text-align: center;
      font-family: Arial;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      /* 24px */
    }

    .exhibition-exhibition {
      color: #212121;
      font-family: Arial;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      /* 60px */
      text-transform: capitalize;
      margin-bottom: 40px;
    }

    .exhibition-uninet {
      color: #212121;
      font-family: Arial;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      /* 24px */
      text-align: left;
      margin-bottom: 40px;
    }

    .exhibition-footer {
      color: #212121;
      font-family: Arial;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      /* 24px */
      text-align: left;
    }

    .exhibition-shipping {
      display: flex;
      gap: 40px;
      margin-bottom: 40px;

      > div {
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        img {
          width: 60px;
          height: 60px;
          margin-bottom: 22px;
        }

        > div:nth-of-type(1) {
          color: #212121;
          font-family: Arial;
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: 130%;
          /* 26px */
          text-align: left;
          margin-bottom: 16px;
        }

        > div:nth-of-type(2) {
          color: #212121;
          font-family: Arial;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          /* 24px */
          text-align: left;
        }
      }

      .shipping-left {
        img {
          width: 70px;
          height: 70px;
          margin-bottom: 12px;
        }
      }
    }

    .exhibition-simp {
      display: flex;
      gap: 40px;
      margin-bottom: 40px;

      .exhibition-simp-img {
        width: 594px;
        height: 721px;
      }

      .exhibition-simp-list {
        > div:nth-of-type(1) {
          color: var(--color-primary);
          font-family: Arial;
          font-size: 36px;
          font-style: normal;
          font-weight: 600;
          line-height: 130%;
          /* 46.8px */
          margin-bottom: 20px;
          text-align: left;
        }

        > div:nth-of-type(2) {
          color: #212121;
          font-family: Arial;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          /* 33px */
          text-align: left;
          margin-bottom: 20px;
        }

        > div:nth-of-type(3) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          /* 两列布局 */
          gap: 0;
          /* 关键：消除网格间距 */
          width: 100%;

          > div {
            padding: 20px 40px 20px 0px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            img {
              width: 70px;
              height: 70px;
              margin-bottom: 22px;
            }

            > div:nth-of-type(1) {
              color: #212121;
              font-family: Arial;
              font-size: 20px;
              font-style: normal;
              font-weight: 600;
              line-height: 130%;
              /* 26px */
              text-align: left;
              margin-bottom: 12px;
            }

            > div:nth-of-type(2) {
              color: #212121;
              font-family: Arial;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              /* 24px */
              text-align: left;
            }
          }
        }

        .simp-item-btn {
          padding: 20px 40px 20px 0px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          img {
            width: 70px;
            height: 70px;
            margin-bottom: 22px;
          }

          text-align: left;

          > div:nth-of-type(1) {
            color: #212121;
            font-family: Arial;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 130%;
            /* 26px */
            text-align: left;
            margin-bottom: 16px;
          }

          > div:nth-of-type(2) {
            color: #212121;
            font-family: Arial;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            /* 24px */
            text-align: left;
          }
        }
      }
    }
  }
}

// Process
.Process {
  width: 100%;
  // background-color: #fff;
  padding: 80px 0;

  .Process-detail {
    width: 1200px;
    margin: 0 auto;

    .Process-how {
      color: #8f6e00;
      text-align: center;
      font-family: Arial;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      /* 24px */
    }

    .Process-Process {
      color: #212121;
      font-family: Arial;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      /* 60px */
      text-transform: capitalize;
      margin-bottom: 40px;
    }

    .Process-all-list {
      display: flex;
      align-items: center;
      gap: 20px;
    }

    .Process-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      /* 两列布局 */
      gap: 20px;

      /* 关键：消除网格间距 */
      > div {
        cursor: pointer;
        transition: all 0.3s ease;
        width: 386px;
        height: 369px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        padding: 30px;

        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;

        > div:nth-child(1) {
          color: #fff;
          font-family: Arial;
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          text-transform: capitalize;
          margin-bottom: 10px;
          text-align: left;
        }

        > div:nth-child(2) {
          color: #fff;
          font-family: Arial;
          font-size: 16px;
          font-style: normal;
          font-weight: 300;
          line-height: normal;
          // text-transform: capitalize;
          text-align: left;
        }
      }

      /* 动画效果 */
      .slide-enter-active,
      .slide-leave-active {
        transition: all 0.6s ease;
        max-height: 200px;
      }

      .slide-enter-from,
      .slide-leave-to {
        opacity: 0;
        max-height: 0;
        transform: translateY(-10px);
      }

      .accordion-item:hover {
        transform: translateX(5px);
      }
    }

    .Process-list-right {
      > div {
        display: flex;
        width: 590px;
        height: 548px;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;
        gap: 10px;
      }
    }
  }
}

// aboutUs
.aboutUs {
  width: 100%;
  background-color: #fffbf2;
  padding: 80px 0 160px 0;

  .aboutUs-detail {
    width: 1200px;
    margin: 0 auto;

    .aboutUs-why {
      color: #8f6e00;
      text-align: center;
      font-family: Arial;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      /* 24px */
    }

    .aboutUs-aboutUs {
      color: #212121;
      font-family: Arial;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      /* 60px */
      text-transform: capitalize;
      margin-bottom: 50px;
    }

    .aboutUs-content {
      display: flex;
      align-items: flex-start;

      > div:nth-child(1) {
        color: #212121;
        font-family: Arial;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        /* 36px */
        text-align: left;

        padding-left: 20px;
        border-left: 6px solid #8f6e00;

        flex: 0 0 468px;
        margin-top: 48px;
      }

      > div:nth-child(2) {
        flex: 1;
        color: #212121;
        text-align: justify;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        .title1 {
          margin-top: 10px;
          font-size: 18px;
          font-weight: 600;
          line-height: 27px;
        }
        .title2 {
          font-weight: 500;
          line-height: 27px;
        }
        .nums {
          margin-top: 38px;
          background-image: url(../assets/about-us-bg.png);
          background-repeat: no-repeat;
          background-position-x: right;
          .nums-grid {
            display: grid;
            grid-template-columns: repeat(2, 106px);
            gap: 20px;
            .grid-item {
              color: #212121;
              font-size: 16px;
              font-weight: 400;
              line-height: 36px;
              > div:nth-child(1) {
                color: #c39500;
                font-size: 24px;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
}

// contactUs
.contactUs {
  width: 100%;
  padding: 80px 0;
  height: 644px;
  background: url('@/assets/footer-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .contactUs-detail {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 30px 52px;

    .contactUs-left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 296px;

      > div:nth-of-type(1) {
        display: flex;
        gap: 10px;
        padding: 16px 60px 16px 0px;
        margin-bottom: 40px;

        align-items: center;

        > div:nth-child(1) {
          width: 36px;
          height: 36px;
        }

        > div:nth-child(2) {
          color: #fff;
          font-family: Arial;
          font-size: 16px;
          font-style: normal;
          font-weight: 300;
          line-height: 150%;
          /* 24px */
          text-align: left;
        }
      }

      > div:nth-of-type(2) {
        color: #fff;
        font-family: Arial;
        font-size: 26px;
        font-style: normal;
        font-weight: 600;
        line-height: 33.8px;
        text-transform: capitalize;
        margin-bottom: 30px;

        > div {
          margin-bottom: 10px;
        }

        > p {
          width: 60px;
          height: 3px;
          background-color: #fff;
        }
      }

      > div:nth-of-type(3) {
        color: #fff;
        font-family: Arial;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 24px;
        margin-bottom: 30px;
        text-align: left;
      }

      > div:nth-of-type(4) {
        cursor: pointer;
        display: flex;
        gap: 10px;
        margin-bottom: 40px;

        img {
          width: 32px;
          height: 32px;
        }
      }

      > img {
        width: 250px;
        height: 75px;
      }
    }

    .contactUs-mid {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 235px;

      > div:nth-of-type(1) {
        display: flex;
        gap: 10px;
        padding: 16px 60px 16px 0px;
        margin-bottom: 40px;

        align-items: center;

        > div:nth-child(1) {
          width: 36px;
          height: 36px;
        }

        > div:nth-child(2) {
          color: #fff;
          font-family: Arial;
          font-size: 16px;
          font-style: normal;
          font-weight: 300;
          line-height: 24px;
          text-align: left;
        }
      }

      > div:nth-of-type(2) {
        color: #fff;
        font-family: Arial;
        font-size: 26px;
        font-style: normal;
        font-weight: 600;
        line-height: 33.8px;
        text-transform: capitalize;
        margin-bottom: 30px;

        > div {
          margin-bottom: 10px;
        }

        > p {
          width: 60px;
          height: 3px;
          background-color: #fff;
        }
      }

      > div:nth-of-type(3) {
        color: #fff;
        font-family: Arial;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 24px;
        margin-bottom: 20px;
        text-align: left;
      }

      > div:nth-of-type(4) {
        color: #fff;
        font-family: Arial;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 24px;
        margin-bottom: 20px;
        text-align: left;
      }

      > div:nth-of-type(5) {
        color: #fff;
        font-family: Arial;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 24px;
        margin-bottom: 20px;
        text-align: left;
      }

      > div:nth-of-type(6) {
        color: #fff;
        font-family: Arial;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 24px;
        margin-bottom: 20px;
        text-align: left;
      }
    }

    .contactUs-right {
      width: 528px;
      height: 640px;
      background-color: #072164;
      padding: 40px;
      margin-top: -150px;

      .contactus-right-title {
        color: #fff;
        font-family: Arial;
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: 52px;
        text-transform: capitalize;
        text-align: left;

        > span:nth-child(even) {
          color: #ffd342;
          font-family: Arial;
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: 130%;
          text-transform: capitalize;
          padding: 5px;
        }
      }
    }
  }
}

/* 底部样式 */
.footer {
  background: #0a1f54;
  color: white;
  text-align: center;
  padding: 20px;
  margin-top: auto;
  color: rgba(255, 255, 255, 0.6);
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
</style>
